module.exports = __webpack_public_path__ + "static/img/so.5564fcba.png";